import React from "react";

import "./door.module.scss";

export const Door = ({ isOpen }) => {
  const classNames = (className, open) => `${className} ${open ? "open" : ""}`;
  const strokeWidth = 1;
  const strokeBlackColor = "#000";
  const fillWhite = "#D5E5F6";
  const doorColor = "#1d1e2c";
  const handleColor = "#F4F3F1";
  return (<svg className="svg-wrapper" style={{ width: 390, height: 370 }} viewBox="0 0 280 240">
    <g className={classNames("left", isOpen)}>
      <rect
        fill={doorColor}
        stroke={strokeBlackColor}
        strokeWidth={strokeWidth}
        x="20"
        y="0"
        width="120"
        height="240"
      />
       <rect
        fill={fillWhite}
        stroke={fillWhite}
        strokeWidth={strokeWidth}
        x="50"
        y="30"
        width="50"
        height="40"
      />
      <path
        strokeLinecap="round"
        strokeWidth={5}
        stroke={handleColor}
        d="M120,120 l0,20"
      />
    </g>
    <g className={classNames("right", isOpen)}>
      <rect
        fill={doorColor}
        stroke={strokeBlackColor}
        strokeWidth={strokeWidth}
        x="140"
        y="0"
        width="120"
        height="240"
      />
       <rect
        fill={fillWhite}
        stroke={fillWhite}
        strokeWidth={strokeWidth}
        x="180"
        y="30"
        width="50"
        height="40"
      />
      <path
        strokeLinecap="round"
        strokeWidth={5}
        stroke={handleColor}
        d="M160,120 l0,20"
      />
    </g>
  </svg>);
};
